<template>
  <div class="page-content">
    <div class="exhibit-header">
      <img class="banner" src="../assets/images/perform.png" alt="">
      <div class="header-title w">
        <span class="yh1">举办大型展览展销活动“—件事”</span>
         <span  class="yh2">在本市举办以营利为目的，单场次参加人数1000人以上，租用、借用或者以其他形式临时占用场所、场地的展览展销活动。</span>
      </div>
    </div>
    <div class="zcjd">
      <div class="list" style="margin:auto auto;">
        <ul>
          <li><a href="../../dxzlzxhd.pdf" target="_blank"><span>办事指南</span></a></li>
          <i></i>
          <li><a href="../dxzlzxJd"><span>“一件事”解读</span></a></li>
          <i></i>
          <li><a href="../hdsblv/home" target="_blank"><span>立即办理</span></a></li>
          <i></i>
          <li><a href="../denglv" target="_blank"><span>进度查询</span></a></li>
        </ul>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "DxzlzxHome"
}
</script>

<style scoped>
.page-content{
  min-height: calc(100vh - 160px);
  display: flex;
  flex-direction: column;
  align-content: center;
  align-items: center;
  justify-content: flex-start;
}
.zcjd{
  display: flex;
  flex-direction: column;
  flex-wrap: nowrap;
  align-items: center;
}
.exhibit-header{width:100%;height:200px;position:relative;min-width:1200px;overflow: hidden;background-color: #0356ad;
  margin-top: 40px;
  margin-bottom: 40px;
}
.banner{min-width:400px;position:absolute;left:85%;top:0;height:200px;transform: translate(-50%,0);}
.header-title{bottom:0px;position:absolute;height:140px;z-index:999999999;
  box-sizing: border-box;}
.yh1{position:absolute;top:0px;left:30px;font-size:40px;}
.yh2{position:absolute;bottom:10px;left:30px;font-size:18px;}
.header-title span{display:block;color:#fff;width:800px;}
.list{margin-top:50px;float:left;}
.list ul{
  list-style: none;
}
.list li{width:200px;float:left;height:140px;font-size:24px;line-height:80px;box-sizing: border-box;margin-left:46px;position:relative;}
.list li a{display:block;color:#000;width: 100%;height: 100%;box-sizing: border-box;text-align:center;}
.list li a span{height:60px;display:block;line-height:200px;}
.sj{position:absolute;width:20px;height:20px;background-color: #0356ad;border-right:none;border-bottom:none;bottom:-11px;left:50%;transform:translate(-50%,0) rotate(45deg);z-index:9999999999999;}
.list li:hover{background-color: #0356ad;}
.list li:hover a{color:#fff;}
.list i{display:block;height:75px;width:1px;background-color: #D8D8D8;float:left;margin:27px 0px 0px 50px;}
.list li:nth-child(1) a{text-decoration: none;background: url(../assets/images/bszn.png) no-repeat 80px 20px;}
.list li:nth-child(3) a{text-decoration: none;background: url(../assets/images/fwgl.png) no-repeat 80px 20px;}
.list li:nth-child(5) a{text-decoration: none;background: url(../assets/images/ljbl.png) no-repeat 80px 20px;}
.list li:nth-child(7) a{text-decoration: none;background: url(../assets/images/jdcx.png) no-repeat 80px 20px;}
.list li:nth-child(1) a:hover{text-decoration: none;background: url(../assets/images/bszn_b.png) no-repeat 80px 20px;}
.list li:nth-child(3) a{text-decoration: none;background: url(../assets/images/fwgl_b.png) no-repeat 80px 20px;}
.list li:nth-child(5) a:hover{text-decoration: none;background: url(../assets/images/ljbl_b.png) no-repeat 80px 20px;}
.list li:nth-child(7) a:hover{text-decoration: none;background: url(../assets/images/jdcx_b.png) no-repeat 80px 20px;}

.list li:nth-child(3):hover{background-color: #0356ad;}
.list li:nth-child(3) a{color:#000;}
.list li:nth-child(3) a:hover{color:#fff;}
.list li:nth-child(3) a{background: url(../assets/images/fwgl.png) no-repeat 80px 20px;}
.list li:nth-child(3) a:hover{background: url(../assets/images/fwgl_b.png) no-repeat 80px 20px;}
</style>
